import { findKey } from 'lodash'

export const attributesMap = {
  1: { label: 'VIP', type: 'normal' },
  2: { label: 'リピーター', type: 'normal' },
  3: { label: '要注意', type: 'bad' },
  4: { label: '無断キャンセル', type: 'bad' },
}

export function getAttributesCodeListByStr(attributesStrList) {
  return attributesStrList.map(attributesStr => +findKey(attributesMap, mapObj => mapObj.label === attributesStr))
}

export function getAttributesStrListByCodeAndType(attributesCodeList, type) {
  const attributesStrList = []

  attributesCodeList.forEach(code => {
    const mapObj = attributesMap[code]
    if (mapObj && mapObj.type === type) {
      attributesStrList.push(mapObj.label)
    }
  })

  return attributesStrList
}
